import { useEffect } from 'react'
import QueryString from 'query-string'
import Axios from '../../apis/axiosClient'
import PageSkeleton from '../../components/PageSkeleton'
import { jwtStorage } from '../../utils/jwtStorage'
import { popReturnTo } from '../../utils/returnTo'
import { LOGIN_ROUTE } from '../../routes'
import { AUTH_LINREST_API_GATEWAY_URL } from '../../constants/apis'
import { useNavigate } from 'react-router-dom'
const OAuthHandler = () => {
  const providerName = 'backoffice_google_identity'

  const navigate = useNavigate()
  const search = QueryString.parse(window.location.search)

  const encodedSearch = QueryString.stringify(
    { ...search },
    { encode: true, strict: true }
  )

  const identityUrl = `${AUTH_LINREST_API_GATEWAY_URL}/api/v1/rest/public/auth/backoffice-identity/success/${providerName}?${encodedSearch}`

  useEffect(() => {
    window.history.replaceState({}, document.title, '/')
    const validateAndGetToken = async () => {
      try {
        const {
          data: { token }
        } = await Axios.get(identityUrl, { withCredentials: true })
        jwtStorage.set(token)
        navigate(popReturnTo())
      } catch (err) {
        const errorMessage =
          err?.response?.data?.description ||
          err?.response?.data?.error ||
          'Login failed. Please try again.'
        navigate(LOGIN_ROUTE.route, { state: { error: errorMessage } })
      }
    }
    validateAndGetToken()
  }, [identityUrl, navigate])

  return <PageSkeleton message='Signing you in...' />
}

export default OAuthHandler
